<template>
  <div class="about main_content_box">
    <div class="main_content_card flex_box">
      <div class="about-nav">
        <h4>
          关于我们
        </h4>
        <ul>
          <!--<li>其他文章标题</li>-->
          <!--<li>其他文章标题</li>-->
        </ul>
      </div>
      <div class="text">
        <p>
          绿孔雀是世界上体型最大（体长180-230cm）、羽毛最华丽的雉类动物。它体态优美，深受中国古代诗人的喜爱，“碧凤一飞去，空遗碧鸡名”等类似对绿孔雀的描述曾频繁出现在诗词歌赋中。“碧凤”的原型就是中国本土孔雀物种——绿孔雀，而如今，绿孔雀仅在中国云南省少数几个县被发现。来自中国科学院昆明动物研究所的调查分析显示，作为中国唯一的一种原生孔雀，绿孔雀目前在中国非常稀有，数量不到500只，比20年前少了一半，且数量一直在呈下降趋势。生境破碎，小种群之间缺乏交流，绿孔雀已经比大熊猫还濒危。
        </p>
        <p>
          2017年底，由云南省林草局牵头，阿拉善SEE西南项目中心资助与配合管理，专家指导、新平林业局支持、玉溪观鸟会推动，形成了多方参与的管理委员会。由当地林业站与社区村民建立的绿孔雀栖息地（共同）管护区（Green Peafowl Habitat Community Reserve）——新平县绿孔雀栖息地（共同）管护区，探索在自然保护区以外的绿孔雀栖息地开展有效保护，为周边林区残存的绿孔雀和其他动植物提供一个自然保护地，促进绿孔雀种群数量稳定和复壮。
        </p>
        <p>
          保护小区从2017年10月立项至今已将近三年。在过去的三年里，在地执行团队完成了对巡护队的多次培训, 在保护小区内建立红外相机监测网络，实现对该区域内孔雀种群分布、数量的调查与监测数据回收。
        </p>
        <p>
          绿孔雀栖息地（共同）管护区既是在保护绿孔雀及其栖息地，也是一次政府行业主管部门、科研机构、民间组织、社区合作共同管护模式的创新。一场物种保护的行动，促进社会公众关注濒危物种保护、广泛动员社会力量参与生物多样性保护，促进野生动物栖息地周边社区可持续发展。
        </p>
      </div>
      <div class="peacock_img">
        <img src="@/assets/img/peacock.png" alt="绿孔雀" width="100%" height="100%">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {}
  },
  components: {},
  computed: {},
  methods: {},
  watch: {}
}
</script>
<style lang="scss" scoped>
  $img_root_path: '../assets/img/';
  .flex_box {
    display: flex;
    .about-nav {
      width: 307px;
      min-height: calc(100vh - 225px);
      background: #EAEFE6 url($img_root_path + 'green_bg.png') no-repeat;
      background-size: cover;
      @media screen and (max-width: 1000px) {
        /*width: 200px;*/
        display: none;
      }
      h4 {
        width: 100%;
        line-height: 40px;
        height: 40px;
        background: url($img_root_path + 'title_bg.png') no-repeat;
        background-size: cover;
        color: #333E2A;
        font-size: 18px;
        font-weight: 600;
        font-style: italic;
        padding-left: 40px;
        box-sizing: border-box;
      }
      ul {
        margin: 20px 30px;
        padding: 0;
        li {
          line-height: 40px;
          list-style-type: none;
          font-size: 16px;
          font-weight: 600;
          color: #646464;
          margin-bottom: 10px;
        }
      }
    }
    .text {
      flex: 1;
      min-height: calc(100vh - 225px);
      padding: 50px 40px;
      p {
        font-size: 18px;
        font-weight: bold;
        color: #646464;
        line-height: 36px;
        text-indent: 2em;
      }
    }
    .peacock_img {
      width: 553px;
      min-height: calc(100vh - 225px);
      @media screen and (max-width: 1500px) {
        display: none;
      }
    }
  }
</style>
